import { setData } from 'features/public-views/connect-account/connectAccountSlice'
import { getMetaContent } from 'helpers'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Card, CardBody, CardTitle } from 'reactstrap'

const SuccessVerifyAccount = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setData(null))
  }, [])

  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center min-vh-100 bg-light">
        <Card style={{ maxWidth: '600px', width: '100%' }} data-testid="success-verify-account-message">
          <CardBody>
            <div className="d-flex justify-content-center align-items-center mb-3">
              <img
                alt={`${getMetaContent('og:title')} logo`}
                src={getMetaContent('og:image')}
                style={{
                  width: '100%',
                  maxWidth: '150px',
                  height: 'auto',
                }}
              />
            </div>
            <CardTitle
              className="d-flex justify-content-center align-items-center mb-4 text-center"
              tag="h2"
            >
              Anda akan diberikan akses ke PasarMIKRO Business melalui email,
              silakan cek secara berkala.
            </CardTitle>
          </CardBody>
        </Card>
      </div>
    </>
  )
}

export default SuccessVerifyAccount
